<template>
 <div></div>
</template>

<script>
export default {
  name: "PaymentInfo"
}
</script>

<style scoped>

</style>